import './lib/suppressThirdPartyConsole';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import './index.css';
import { queryClient } from './lib/queryClient';
import { bindAnalyticsToAuth, initAnalytics } from './lib/analytics';
import PostHogErrorBoundary from './components/PostHogErrorBoundary';

// PostHog: no-ops without VITE_POSTHOG_KEY. Bound to the auth store once so
// identify/reset follow login, onboarding (org created) and logout.
initAnalytics();
bindAnalyticsToAuth();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <PostHogErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </PostHogErrorBoundary>
  </React.StrictMode>
);

